import styles from '../../SizeAndWeightStyles.module.css'
import Required from '../../Required/Required';
import NumberField from '../../NumberFields/NumberFields';
import deleteButton from '../../../../../Assets/deleteButton.png'
import addButton from '../../../../../Assets/addButton.png'
import { useStyles } from '../../../../../Styles/styles';

const AxleWeightRow = ({
  axle = null,
  axleName = "",
  dispatch = () => { console.error("No dispatch function provided") },
  updateAxleWeight = () => { console.error("No updateAxleWeight function provided") },
  axleGroupId = null,
  missingFields = [],
  removeAxle = () => { console.error("No removeAxle function provided") },
  addAxle = () => { console.error("No addAxle function provided") },
  isLast = false,
  disabled = true,
}) => {
  const classes = useStyles();

  const { leftAxleWeight, rightAxleWeight, totalAxleWeight } = axle;

  const updateWeight = (intVal, action, propertyObj) => {
    const newSum = propertyObj?.property === 'leftAxleWeight' ? +intVal + +rightAxleWeight : +leftAxleWeight + +intVal;
    return updateAxleWeight(axle?.id, intVal, propertyObj?.property, axleGroupId, newSum);
  }

  return (
    <div id={"axle-weight-row-container-"+axle?.id} className={styles['flexRow']}>
      <Required
        required={missingFields.some(field => field?.name === "leftAxleWeight") && (!Number.isInteger(leftAxleWeight) || leftAxleWeight <= 0)}
        message={missingFields.find(field => field?.name === "leftAxleWeight")?.error}
      >
        <NumberField
          id={"left-axle-weight-"+axle?.id}
          value={leftAxleWeight}
          dispatch={dispatch}
          label={"Left " + axleName}
          handleBlur={updateWeight}
          action={"UPDATE_AXLE"}
          property={"leftAxleWeight"}
          lbs={true}
          payload={{ axleGroupId: axleGroupId, axleId: axle?.id, property: 'leftAxleWeight' }}
          disabled={disabled}
        />
      </Required>
      <Required
        required={missingFields.some(field => field?.name === "rightAxleWeight") && (!Number.isInteger(rightAxleWeight) || rightAxleWeight <= 0)}
        message={missingFields.find(field => field?.name === "rightAxleWeight")?.error}
      >
        <NumberField
          id={"right-axle-weight-"+axle?.id}
          value={rightAxleWeight}
          dispatch={dispatch}
          handleBlur={updateWeight}
          action={"UPDATE_AXLE"}
          property={"rightAxleWeight"}
          label={"Right " + axleName}
          lbs={true}
          payload={{ axleGroupId: axleGroupId, axleId: axle?.id, property: 'rightAxleWeight' }}
          disabled={disabled}
        />
      </Required>
      <NumberField
        id={"total-axle-weight-"+axle?.id}
        lbs={true}
        value={totalAxleWeight}
        label={'Total Axle Weight'}
        disabled={true}
      />
      <button
        type="button"
        onClick={() => !disabled && removeAxle(axle?.id)}
        disabled={disabled}
        style={{ background: "none", border: 0, padding: 0 }}
      >
        <img
          data-cy={"delete-axle-button-" + axle?.id}
          src={deleteButton}
          className={disabled ? classes.disabledPngButton : classes.pngButton}
          alt="Delete Axle"
        />
      </button>
      {isLast && (
        <button
          type="button"
          onClick={() => !disabled && addAxle()}
          disabled={disabled}
          style={{ background: "none", border: 0, padding: 0 }}
        >
          <img
            data-cy={"add-axle-button-" + axle?.id}
            src={addButton}
            className={disabled ? classes.disabledPngButton : classes.pngButton}
            alt="Add Axle"
          />
        </button>
      )}
    </div>
  )
}

export default AxleWeightRow;
